// removed by extract-text-webpack-plugin
module.exports = {"image":"imageTheme__image___6_jX7","imageLoaded":"imageTheme__imageLoaded___exXYq","container":"imageTheme__container___2pSS5"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Review/imageTheme.scss
// module id = 1305
// module chunks = 0